import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowRight, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import "./HowItWorksCTA.css";

gsap.registerPlugin(ScrollTrigger);

const HowItWorksCTA = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        contentRef.current,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="how-it-works-cta" ref={sectionRef}>
      <div className="how-it-works-cta__container">
        <div className="how-it-works-cta__content" ref={contentRef}>
          <div className="how-it-works-cta__icon">
            <Calendar size={48} strokeWidth={1.5} />
          </div>

          <h2 className="how-it-works-cta__headline">
            Ready to See It In Action?
          </h2>
          <p className="how-it-works-cta__description">
            Book a free strategy call and we'll walk you through exactly how
            this process will work for your clinic. No pressure, no commitments
            just a clear roadmap to predictable growth.
          </p>

          <div className="how-it-works-cta__buttons">
            <Link
              to="/contact"
              className="how-it-works-cta__btn how-it-works-cta__btn--primary"
            >
              <Calendar size={20} />
              Book Your Free Call
              <ArrowRight size={20} />
            </Link>
            <Link
              to="/services"
              className="how-it-works-cta__btn how-it-works-cta__btn--secondary"
            >
              View Our Services
            </Link>
          </div>

          <p className="how-it-works-cta__note">
            <span className="how-it-works-cta__note-icon">✓</span>
            30-minute strategy session • No obligation • Instant value
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksCTA;
